import { getShopSetting } from 'api/service';
import { SET_SETTING } from 'states/constants';

export const getSettingAction = (dispatch) => async () => {
  getShopSetting((success, data) => {
    if (success) {
      var modelofdata = data.data;
      var modelofattach = {
        ...modelofdata,
        hasExtendedInProgress: modelofdata.hasExtendedInProgress,
      };
      var modelofattachactivatings = {
        ...modelofattach,
        hasextendedActive: modelofdata.hasextendedActive,
      };
      setSettingAction(dispatch)(modelofattachactivatings);
    }
  });
};
export const setSettingAction = (dispatch) => async (data) => {
  dispatch({
    type: SET_SETTING,
    payload: data,
  });
};
